module.exports = {"versionNumber":"1.0.0","buildNumber":1001}


//////////////////
// WEBPACK FOOTER
// ./src/config/meta.json
// module id = 2264
// module chunks = 0